// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file api/core/svc_patient_document.proto (package com.diagnocat.core, syntax proto3)
/* eslint-disable */

import { proto3 } from "@bufbuild/protobuf";
import { PatientDocument } from "../../model/dto_patient_document_pb.js";
import { MedicalImageViewOptions } from "../../model/dto_common_image_view_options_pb.js";
import { Asset } from "../../model/dto_asset_pb.js";

/**
 * @generated from message com.diagnocat.core.ListPatientDocumentsReq
 */
export const ListPatientDocumentsReq = proto3.makeMessageType(
  "com.diagnocat.core.ListPatientDocumentsReq",
  () => [
    { no: 1, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.ListPatientDocumentsResp
 */
export const ListPatientDocumentsResp = proto3.makeMessageType(
  "com.diagnocat.core.ListPatientDocumentsResp",
  () => [
    { no: 1, name: "Documents", kind: "message", T: PatientDocument, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.GetPatientDocumentReq
 */
export const GetPatientDocumentReq = proto3.makeMessageType(
  "com.diagnocat.core.GetPatientDocumentReq",
  () => [
    { no: 1, name: "DocumentID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.GetPatientDocumentResp
 */
export const GetPatientDocumentResp = proto3.makeMessageType(
  "com.diagnocat.core.GetPatientDocumentResp",
  () => [
    { no: 1, name: "Document", kind: "message", T: PatientDocument },
  ],
);

/**
 * @generated from message com.diagnocat.core.CreatePatientDocumentReq
 */
export const CreatePatientDocumentReq = proto3.makeMessageType(
  "com.diagnocat.core.CreatePatientDocumentReq",
  () => [
    { no: 1, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "OriginThreadID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.CreatePatientDocumentResp
 */
export const CreatePatientDocumentResp = proto3.makeMessageType(
  "com.diagnocat.core.CreatePatientDocumentResp",
  () => [
    { no: 1, name: "Document", kind: "message", T: PatientDocument },
  ],
);

/**
 * @generated from message com.diagnocat.core.UpdatePatientDocumentReq
 */
export const UpdatePatientDocumentReq = proto3.makeMessageType(
  "com.diagnocat.core.UpdatePatientDocumentReq",
  () => [
    { no: 1, name: "DocumentID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "ExpectedRevision", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.UpdatePatientDocumentResp
 */
export const UpdatePatientDocumentResp = proto3.makeMessageType(
  "com.diagnocat.core.UpdatePatientDocumentResp",
  () => [
    { no: 1, name: "Document", kind: "message", T: PatientDocument },
  ],
);

/**
 * @generated from message com.diagnocat.core.DeletePatientDocumentReq
 */
export const DeletePatientDocumentReq = proto3.makeMessageType(
  "com.diagnocat.core.DeletePatientDocumentReq",
  () => [
    { no: 1, name: "DocumentID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.DeletePatientDocumentResp
 */
export const DeletePatientDocumentResp = proto3.makeMessageType(
  "com.diagnocat.core.DeletePatientDocumentResp",
  [],
);

/**
 * @generated from message com.diagnocat.core.AddPatientDocumentImageReq
 */
export const AddPatientDocumentImageReq = proto3.makeMessageType(
  "com.diagnocat.core.AddPatientDocumentImageReq",
  () => [
    { no: 1, name: "DocumentID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "AssetID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Caption", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "ViewOptions", kind: "message", T: MedicalImageViewOptions },
    { no: 5, name: "ExpectedRevision", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.AddPatientDocumentImageResp
 */
export const AddPatientDocumentImageResp = proto3.makeMessageType(
  "com.diagnocat.core.AddPatientDocumentImageResp",
  () => [
    { no: 1, name: "Document", kind: "message", T: PatientDocument },
  ],
);

/**
 * @generated from message com.diagnocat.core.UpdatePatientDocumentImageReq
 */
export const UpdatePatientDocumentImageReq = proto3.makeMessageType(
  "com.diagnocat.core.UpdatePatientDocumentImageReq",
  () => [
    { no: 1, name: "DocumentID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ImageID", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "Caption", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "ViewOptions", kind: "message", T: MedicalImageViewOptions },
    { no: 5, name: "ExpectedRevision", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.UpdatePatientDocumentImageResp
 */
export const UpdatePatientDocumentImageResp = proto3.makeMessageType(
  "com.diagnocat.core.UpdatePatientDocumentImageResp",
  () => [
    { no: 1, name: "Document", kind: "message", T: PatientDocument },
  ],
);

/**
 * @generated from message com.diagnocat.core.ReorderPatientDocumentImagesReq
 */
export const ReorderPatientDocumentImagesReq = proto3.makeMessageType(
  "com.diagnocat.core.ReorderPatientDocumentImagesReq",
  () => [
    { no: 1, name: "DocumentID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ImageIDs", kind: "scalar", T: 13 /* ScalarType.UINT32 */, repeated: true },
    { no: 3, name: "ExpectedRevision", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.ReorderPatientDocumentImagesResp
 */
export const ReorderPatientDocumentImagesResp = proto3.makeMessageType(
  "com.diagnocat.core.ReorderPatientDocumentImagesResp",
  () => [
    { no: 1, name: "Document", kind: "message", T: PatientDocument },
  ],
);

/**
 * @generated from message com.diagnocat.core.RemovePatientDocumentImageReq
 */
export const RemovePatientDocumentImageReq = proto3.makeMessageType(
  "com.diagnocat.core.RemovePatientDocumentImageReq",
  () => [
    { no: 1, name: "DocumentID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ImageID", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "ExpectedRevision", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.RemovePatientDocumentImageResp
 */
export const RemovePatientDocumentImageResp = proto3.makeMessageType(
  "com.diagnocat.core.RemovePatientDocumentImageResp",
  () => [
    { no: 1, name: "Document", kind: "message", T: PatientDocument },
  ],
);

/**
 * @generated from message com.diagnocat.core.ListPatientDocumentSourceAssetsReq
 */
export const ListPatientDocumentSourceAssetsReq = proto3.makeMessageType(
  "com.diagnocat.core.ListPatientDocumentSourceAssetsReq",
  () => [
    { no: 1, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ToothISO", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.PatientDocumentSourceAsset
 */
export const PatientDocumentSourceAsset = proto3.makeMessageType(
  "com.diagnocat.core.PatientDocumentSourceAsset",
  () => [
    { no: 1, name: "Asset", kind: "message", T: Asset },
    { no: 2, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.ListPatientDocumentSourceAssetsResp
 */
export const ListPatientDocumentSourceAssetsResp = proto3.makeMessageType(
  "com.diagnocat.core.ListPatientDocumentSourceAssetsResp",
  () => [
    { no: 1, name: "Assets", kind: "message", T: PatientDocumentSourceAsset, repeated: true },
  ],
);

